// ./src/pages/privates/Contract/New/StepFinished/index.tsx
import React from 'react';

import { LottieCheck } from '@assets/animations';
import { SubtitleSecondary, Paragraph, ButtonMain } from '@components/index';
import { newProviderStorageService } from '@services/index';

import { Container, Buttons } from './styles';

interface IProps {
  myStep: number;
  currentStep: number;
  changeStep(newStep: number, willChangeHistory?: boolean): void;
}

const StepFinished: React.FC<IProps> = ({ changeStep }) => {
  const handleSellToNewCustomer = () => {
    newProviderStorageService.cleanMany();
    changeStep(1, true);
  };

  return (
    <Container>
      <LottieCheck />
      <SubtitleSecondary>Deu tudo certo!</SubtitleSecondary>
      <Paragraph nameColor="black" fontWeight={500}>
        Este prestador foi cadastrado com sucesso.
      </Paragraph>
      <Buttons>
        <ButtonMain
          onClick={handleSellToNewCustomer}
          style={{ maxWidth: '300px', marginBottom: '1.5vh' }}
        >
          Cadastrar novo prestador
        </ButtonMain>
      </Buttons>
    </Container>
  );
};

export default StepFinished;
